import React from "react";
import { useSelector } from "react-redux";

import { currency } from "@helpers";

import shareData from "../../../../shared/shareData";
import { CreditContainer } from "./style";
import { CreditMenu } from "./CreditMenu";

const Credit = () => {
  const credit = useSelector((state) => state.user.credit);
  const hasCredit = useSelector((state) => state.user.company.hasCredit);

  return hasCredit && shareData.menu.showPrice ? (
    <CreditContainer>
      <CreditMenu
        options={[
          {
            id: 1,
            credit: currency(credit.companyCredit.value, false),
            title: credit.companyCredit.title,
            tooltip: "مانده اعتبار ماهانه اختصاص یافته توسط شرکت به شما",
          },
          {
            id: 2,
            credit: currency(credit.credit.value, false),
            title: credit.credit.title,
            tooltip: "جمع پرداختی این ماه شما به صورت کسر از حقوق",
          },
          {
            id: 3,
            credit: currency(credit.onlineCredit.value, false),
            title: credit.onlineCredit.title,
            tooltip: "مانده اعتبار نقدی در کیف پول شارژ شده",
          },
        ]}
        defaultText={`مدیریت کیف پول`}
      />
    </CreditContainer>
  ) : null;
};

export default Credit;
